import { useState } from 'react';
import './FlagsAndActionsTab.scss';
import FlagList from './FlagList';
import AutosaveAndWithdrawal from './AutosaveAndWithdrawal';
import FlagManager from './FlagManager';
import AccountStatusManager from './AccountStatusManager';
import HoldManager from './HoldManager';
import useRolePermissions from '../../../../hooks/useRolePermissions';
import useCustomers from '../../../../hooks/useCustomers';

const FlagAndActionsTab = ({ userId }: any) => {
  const [activeTab, setActiveTab] = useState('flagList');
  const { restrictActionByRole } = useRolePermissions({});
  const { setWithdrawalDelay, isRunningUserAction } = useCustomers();

  return (
    <div className="flags-and-actions">
      <div className="flags-and-actions__navs">
        <div
          className={`flags-and-actions__navs__item ${activeTab === 'flagList' ? 'active' : ''}`}
          onClick={() => setActiveTab('flagList')}
        >
          Flag List
        </div>
        <div
          className={`flags-and-actions__navs__item ${activeTab === 'flagManager' ? 'active' : ''}`}
          onClick={() => setActiveTab('flagManager')}
        >
          Flag Manager
        </div>
        <div
          className={`flags-and-actions__navs__item ${activeTab === 'accountStatus' ? 'active' : ''}`}
          onClick={() => setActiveTab('accountStatus')}
        >
          Account Status
        </div>
        <div
          className={`flags-and-actions__navs__item ${activeTab === 'holdManager' ? 'active' : ''}`}
          onClick={() => setActiveTab('holdManager')}
        >
          Hold Manager
        </div>
        <div
          className={`flags-and-actions__navs__item ${activeTab === 'autosave' ? 'active' : ''}`}
          onClick={() => setActiveTab('autosave')}
        >
          Autosave
        </div>
        <div
          className={`flags-and-actions__navs__item ${activeTab === 'withdrawal-delay' ? 'active' : ''}`}
          onClick={() => setActiveTab('withdrawal-delay')}
        >
          Withdrawal Delay
        </div>
        <div
          className={`flags-and-actions__navs__item ${activeTab === 'withdrawal-day' ? 'active' : ''}`}
          onClick={() => setActiveTab('withdrawal-day')}
        >
          Withdrawal Day
        </div>
      </div>

      <div>
        {activeTab === 'flagList' && <FlagList userId={userId} />}
        {activeTab === 'flagManager' && <FlagManager UserId={userId} />}
        {activeTab === 'accountStatus' && <AccountStatusManager UserId={userId} />}
        {activeTab === 'holdManager' && <HoldManager UserId={userId} />}
        {(activeTab === 'autosave' || activeTab.includes('withdrawal')) && (
          <AutosaveAndWithdrawal
            context={activeTab}
            restrictActionByRole={restrictActionByRole}
            userId={userId}
            setWithdrawalDelay={setWithdrawalDelay}
            isRunningUserAction={isRunningUserAction}
          />
        )}
      </div>
    </div>
  );
};
export default FlagAndActionsTab;
